import { render, staticRenderFns } from "./form-actions.vue?vue&type=template&id=c523e354&scoped=true&"
import script from "./form-actions.vue?vue&type=script&lang=js&"
export * from "./form-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c523e354",
  null
  
)

export default component.exports